import { render } from "./create-alternative-device.vue?vue&type=template&id=1c636184&scoped=true"
import script from "./create-alternative-device.vue?vue&type=script&lang=js"
export * from "./create-alternative-device.vue?vue&type=script&lang=js"

import "./create-alternative-device.vue?vue&type=style&index=0&id=1c636184&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c636184"]])

export default __exports__